import React, { useState, useEffect } from 'react';
import { FiX, FiSettings } from 'react-icons/fi';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString(),
    }));
    setIsVisible(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      ...preferences,
      timestamp: new Date().toISOString(),
    }));
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString(),
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-dark-card border border-dark-border rounded-2xl p-6 shadow-2xl">
          {!showSettings ? (
            <>
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-2">
                    Gestion des cookies
                  </h3>
                  <p className="text-dark-muted text-sm">
                    Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu.
                    En continuant, vous acceptez notre utilisation des cookies.
                  </p>
                </div>
                <button
                  onClick={() => setIsVisible(false)}
                  className="text-dark-muted hover:text-white transition-colors ml-4"
                  aria-label="Fermer"
                >
                  <FiX className="w-5 h-5" />
                </button>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleAcceptAll}
                  className="flex-1 bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Tout accepter
                </button>
                <button
                  onClick={() => setShowSettings(true)}
                  className="flex-1 bg-dark-surface hover:bg-dark-border text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <FiSettings className="w-4 h-4" />
                  Personnaliser
                </button>
                <button
                  onClick={handleRejectAll}
                  className="flex-1 bg-dark-surface hover:bg-dark-border text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Tout refuser
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-start justify-between mb-6">
                <h3 className="text-xl font-bold text-white">
                  Paramètres des cookies
                </h3>
                <button
                  onClick={() => setShowSettings(false)}
                  className="text-dark-muted hover:text-white transition-colors"
                  aria-label="Fermer"
                >
                  <FiX className="w-5 h-5" />
                </button>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-between p-4 bg-dark-surface rounded-lg">
                  <div className="flex-1">
                    <h4 className="font-semibold text-white mb-1">
                      Cookies nécessaires
                    </h4>
                    <p className="text-sm text-dark-muted">
                      Essentiels au fonctionnement du site
                    </p>
                  </div>
                  <input
                    type="checkbox"
                    checked={preferences.necessary}
                    disabled
                    className="w-5 h-5 text-accent-primary rounded"
                  />
                </div>

                <div className="flex items-center justify-between p-4 bg-dark-surface rounded-lg">
                  <div className="flex-1">
                    <h4 className="font-semibold text-white mb-1">
                      Cookies analytiques
                    </h4>
                    <p className="text-sm text-dark-muted">
                      Nous aident à comprendre comment vous utilisez le site
                    </p>
                  </div>
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={(e) =>
                      setPreferences({ ...preferences, analytics: e.target.checked })
                    }
                    className="w-5 h-5 text-accent-primary rounded"
                  />
                </div>

                <div className="flex items-center justify-between p-4 bg-dark-surface rounded-lg">
                  <div className="flex-1">
                    <h4 className="font-semibold text-white mb-1">
                      Cookies marketing
                    </h4>
                    <p className="text-sm text-dark-muted">
                      Utilisés pour vous proposer des publicités personnalisées
                    </p>
                  </div>
                  <input
                    type="checkbox"
                    checked={preferences.marketing}
                    onChange={(e) =>
                      setPreferences({ ...preferences, marketing: e.target.checked })
                    }
                    className="w-5 h-5 text-accent-primary rounded"
                  />
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleSavePreferences}
                  className="flex-1 bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Enregistrer les préférences
                </button>
                <button
                  onClick={() => setShowSettings(false)}
                  className="flex-1 bg-dark-surface hover:bg-dark-border text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Annuler
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

